<div class="summary-container">
  <h1 class="summary-header">Mass {{summaryData.ActionType }} Selections summary</h1>
  <div class="summary-content">
    <div class="summary-row">
      <span class="summary-label">Hierarchy Type:</span>
      <span>{{ summaryData.HierarchyType }}</span>
    </div>
    @if (summaryData.HierarchyType=='OPL') {
      <div class="summary-row">
        <span class="summary-label">OPL Type:</span>
        <span>{{ summaryData.OPLType }}</span>
      </div>
    }
    <div class="summary-row">
      <span class="summary-label">Owner Group Function:</span>
      <span>{{ summaryData.OwnerGF ? summaryData.OwnerGF.join(', ') : 'All' }}</span>
    </div>
    @if (summaryData.HierarchyType=='ACT') {
      <div class="summary-row">
        <span class="summary-label">Periods:</span>
        <span>{{ summaryData.Periods.length ? summaryData.Periods.join(', ') : 'All (1-12)' }}</span>
      </div>
    }
    <div class="summary-row ">
      <span class="summary-label">Total MgmtIDs Selected: </span>
      <span class="mgmtids">
        <span>{{ summaryData.Mgmtids.length }}</span>
      </span>
    </div>
    <div class="summary-row ">
      <span class="summary-label">Mgmt IDs: </span>
      <span class="mgmtids">
        <span>{{ summaryData.Mgmtids.join(', ') }}</span>
      </span>
    </div>
  </div>

</div>
<div class="stickypanel" style="padding:20px!important">

  <button mat-raised-button (click)="onBackClick()" [disabled]="isLoading" type="submit" class="btn button-fix button-color-fix-red">
    <mat-icon class=" icon-color-fix ">arrow_back_ios</mat-icon>
    Back
  </button>

  <button mat-raised-button (click)="postMassReleaseRevoke()" [disabled]="isLoading" type="submit" class="btn button-fix button-color-fix-orange pull-right">
    @if (!isLoading) {
      <span>{{summaryData.ActionType}} All</span>
    }
    @if (isLoading) {
      <span>Processing...</span>
    }
  </button>

</div>


